module.exports = __webpack_public_path__ + "img/hospital.a7bfddca.png";